<template>
    <div class="flex flex-col bg-white dark:bg-surface-card">
        <B2BHero :type="type" />
        <B2BNumbers :type="type" />
        <B2BCoop :type="type" />
        <B2BGain :type="type" />
        <B2BServices id="sluzby" :type="type" />
        <B2BArticles />
        <B2BReviews id="skusenosti" :type="type" />
        <B2BOffer id="ponuka-spoluprace" />
        <B2BForm id="formular" />
        <B2BValues id="hodnoty" />
        <B2BGetToKnow />
        <EmailNewsletterBlock />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { B2BType } from '#shared/types/B2B'
import EmailNewsletterBlock from '@/components/common/EmailNewsletterBlock.vue'

definePageMeta({
    layout: 'landingpage'
})

useHead({
    title: 'Partnerské riešenia pre verejný sektor | GROWNi.sk',
    meta: [
        { 
            name: 'description',
            content: 'GROWNi ponúka komplexné partnerské riešenia pre organizácie verejného sektora, ktoré môžu priniesť hodnotu občanom a zvýšiť ich zapojenie do procesov.'
        }
    ]
})

const type = ref(B2BType.GOV)
</script>